/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Weight,
    WeightFromJSON,
    WeightFromJSONTyped,
    WeightToJSON,
} from './';

/**
 * 
 * @export
 * @interface WeightFilterItemOutput
 */
export interface WeightFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof WeightFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {Weight}
     * @memberof WeightFilterItemOutput
     */
    value?: Weight;
    /**
     * 
     * @type {boolean}
     * @memberof WeightFilterItemOutput
     */
    isEffective?: boolean;
}

export function WeightFilterItemOutputFromJSON(json: any): WeightFilterItemOutput {
    return WeightFilterItemOutputFromJSONTyped(json, false);
}

export function WeightFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeightFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : WeightFromJSON(json['value']),
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function WeightFilterItemOutputToJSON(value?: WeightFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': WeightToJSON(value.value),
        'isEffective': value.isEffective,
    };
}


